/* Pタグ */
import React from 'react';
import { convertLine } from '../Convert';

interface Props {
  label: string;
  color?: string;
  bold?: boolean;
  css_class?: string;
  is_paragraph?: boolean;
  looks_inactive?: boolean;
}

const Paragraph: React.FC<Props> = ({
  label,
  color = 'text-dark',
  bold,
  css_class = '',
  is_paragraph,
  looks_inactive,
}) => {
  // 太字の設定
  const bold_css = typeof bold !== 'undefined' && bold === true ? 'link-font-bold' : '';
  // 小見出しの規定値
  const heading4 = typeof is_paragraph !== 'undefined' && is_paragraph ? 'heading4' : '';

  //改行\nがlabelに存在する場合はエスケープを外す。
  return (
    <div
      className={`paragraph ${color} ${css_class} ${bold_css} ${heading4} bottom-border ${!looks_inactive &&
        'non-margin-top'}`}
    >
      {convertLine(label)}
    </div>
  );
};

export default Paragraph;
